import axios from "axios";
export default {
    getSummaryReportObjects: (summaryReportId) => axios.post("/SummaryReports/GetSummaryReportObjects", { summaryReportId }),
    getSummaryReportObject: (summaryReportObjectId) => axios.post("/SummaryReports/GetSummaryReportObject", { summaryReportObjectId })
};
